/* global document, Drupal, jQuery */
(($) => {
  Drupal.behaviors.textgrid = {
    attach: () => {
      $(document).ready(() => {
        $('body').once('ilcm-text-grid').each(() => {
          document.querySelectorAll('.paragraph--type-text-grid').forEach((paragraph) => {

            // Init slick
            const slides = paragraph.querySelector('.field--name-field-items');
            $(slides).slick({
              slidesToShow: 1,
              mobileFirst: true,
              centerMode: false,
              draggable: true,
              infinite: false,
              speed: 800,
              swipeToSlide: true,
              responsive: [
                {
                  breakpoint: 1025,
                  settings: "unslick"
                },
                {
                  breakpoint: 660,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
              ],
            });
          });
        });
      });
    },
  };
})(jQuery);
